"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = parseBoolean;
function parseBoolean(value) {
  if (typeof value === 'boolean') {
    return value;
  }
  if (typeof value !== 'string') {
    return false;
  }
  switch (value.toLowerCase()) {
    case 'false':
      return false;
    case 'true':
      return true;
    default:
      return false;
  }
}
//# sourceMappingURL=parseBoolean.js.map